import { useState } from "react";
import XYZ from "ol/source/XYZ";
import { Tile } from "../../reactOL/layers";

const SatelliteOsmTileLayer = () => {
  const [source] = useState(
    () =>
      new XYZ({
        url: "https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2024_3857/default/g/{z}/{y}/{x}.jpg",
        attributions:
          "© Sentinel-2 cloudless by EOX IT Services GmbH (Contains modified Copernicus Sentinel data 2024)",
        maxZoom: 19,
      }),
  );

  return <Tile source={source} />;
};

export default SatelliteOsmTileLayer;
